<template>
  <div>
    <section-header heading="2" ja="機種変更する場合"/>
    <div class="textArea">
      <p>機種を変更される際には登録した「メールアドレスとパスワード」「LINEアカウント」「X(旧Twitter)アカウント」のいずれかを控えていただき、新しいスマホで同じアカウント情報でログインしてください。</p>
      <p>※アカウント情報を忘れると、ログインできず画像なども見れなくなってしまいますので、ご注意ください。</p>
    </div>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutWeb01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onBack() {
      if(sessionStorage.getItem('prevPage')) {
        this.$router.push(sessionStorage.getItem('prevPage'))
      } else {
        this.$router.push('/AboutWeb')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
</style>
